import { Component, inject, Input } from '@angular/core';
import { CommonDetailComponent } from '../common-detail/common-detail.component';
import { PolicyDto } from '../common-detail/policyDto';
import { DatePipe, DecimalPipe } from '@angular/common';
import TravelPolicy from '../../../../../core/data/models/travel.policy.model';
import TravelItem from '../../../../../core/data/models/travel.policy.model';
import { dateFormats } from '../../../../../common/constants/dateFormats';

@Component({
  selector: 'app-travel-detail',
  imports: [CommonDetailComponent],
  providers: [DecimalPipe, DatePipe],
  templateUrl: './travel-detail.component.html',
  styleUrl: './travel-detail.component.css',
})
export class TravelDetailComponent {
  dto: PolicyDto = {} as any;
  policyNumber: string = '';
  travelInfoLabes: {
    label: string;
    attribute: keyof TravelItem;
    type?: 'date' | 'text';
  }[] = [
    {
      label: 'País de origen',
      attribute: 'fromCountry',
    },
    {
      label: 'País de destinos',
      attribute: 'toCountry',
    },
    {
      label: 'Fecha de salida',
      attribute: 'departsOn',
      type: 'date',
    },
    {
      label: 'Cantidad de días',
      attribute: 'days',
    },
  ];
  private readonly decimalPipe = inject(DecimalPipe);
  private readonly datePipe = inject(DatePipe);

  @Input() set policy(policyNumber: string | null) {
    this.policyNumber = policyNumber ? policyNumber : '';
  }

  @Input() set value(policies: TravelPolicy[]) {
    if (policies && policies.length) {
      this.dto = {
        label: `${policies.length} viajes`,
        searchLabel: 'Buscar viaje',
        emptyLabel: 'No tiene viajes asociados a esta póliza',
        policies: policies.map((policy) => {
          const infoLabels = this.travelInfoLabes.map((infoLabel) => {
            let value = policy.travel[infoLabel.attribute];

            switch (infoLabel.type) {
              case 'date':
                value = this.datePipe.transform(
                  value as string,
                  dateFormats.ddMMyyyy,
                ) as any;
                break;
            }

            return {
              label: infoLabel.label,
              value,
            };
          });
          return {
            infoLabels,
            cardContent: `
               <div class="d-flex align-items-center gap-1 my-1">
                  <span><strong>${policy.plan}</strong></span>
              </div>
              <div class="d-flex align-items-center gap-1 my-1">
                  <span>Prima: </span>
                  <strong class="text-primary text-colonial">$${this.decimalPipe.transform(policy.premium, '1.0-0')}</strong>
              </div>

            `,
            coverages: policy.coverages,
            contactInfo: policy.travel.contact,
            passangers: policy.travel.passengers,
            emergencyContactInfo: policy.travel.emergencyContact,
          };
        }),
        detailLabel: 'Información del viaje',
        policyNumber: this.policyNumber,
      };
    }
  }
}
